import { Injectable } from '@angular/core';
import { first, switchMap } from 'rxjs/operators';
import { Observable, from } from 'rxjs';
import { promisify } from 'es6-promisify';
import load from 'little-loader';
import { environment } from '../../../src/environments/environment';


const staticScripts = {
  fingerprint: environment.isWc ? environment.staticScripts.fingerprint : 'assets/scripts/fingerprint2.js',
  uuidv4: environment.isWc ? environment.staticScripts.uuid : 'assets/scripts/uuidv4.js',
  vubrowser: environment.isWc ? environment.staticScripts.vubrowser : 'assets/scripts/vubrowserfp.js'
};

const promisifiedLoad = promisify(load);

const LoadedDeps = Promise.all([
  promisifiedLoad(staticScripts.fingerprint),
  promisifiedLoad(staticScripts.uuidv4),
  promisifiedLoad(staticScripts.vubrowser)
]);

declare const VUBrowserFP;

@Injectable()
export class FingerPrintHandler {

  getFingerprint() {
    return from(LoadedDeps).pipe(
      switchMap(() => {
        const vuFp = new VUBrowserFP();
        return new Observable((observer) => {
          vuFp.getFingerprintInfoWithSeed(function(info) {
            observer.next(info.fingerprint);
          });
        });
      }),
      first()
    ) as Observable<string>;
  }
}
